export const TOGGLE_EVENT = 'm-toggle';
